// store/authSlice.js
import { createSlice } from '@reduxjs/toolkit'

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: {
    userProfile: null,
    unBlockUser:null
  },
  reducers: {
    setUserProfile(state, action) {
      state.userProfile = action.payload
    },
    updateUserProfile(state, action) {
      state.userProfile = { ...(state.userProfile || {}), ...action.payload }
    },
    resetUserProfile(state) {
      state.userProfile = null
    },
    setUnBlockedUser(state, action) {
      state.unBlockUser = action.payload
    },
    resetUnBlockedUser(state) {
      state.unBlockUser = null
    }
  }
})

export const { setUserProfile, updateUserProfile, resetUserProfile,setUnBlockedUser, resetUnBlockedUser } =
    userProfileSlice.actions

export default userProfileSlice.reducer
